/**
 * AUTO-GENERATED — do not edit manually.
 * Run `pnpm sync:tokens --overwrite` to regenerate from Figma (_Foundation / Primitives).
 *
 * Tier 1 foundation colors — mode-invariant. Prefer `theme.tokens.*` for UI surfaces.
 */

import type { PrimitivePalette } from './generated.types'

export const primitives = {
  main: {
    alvieBlue: {
      '20': '#DDE4FD',
      '60': '#9BB0F9',
      '90': '#6C8CFE',
      '100': '#5578F5',
      '110': '#3259E7',
      '120': '#254CD8',
      '140': '#2442AE',
      '160': '#243374',
      '05': '#F5F7FE',
      '30%': '#5578F54D'
    }
  },
  neutrals: {
    white: {
      '100': '#FFFFFF',
      '75%': '#FFFFFFBF',
      '50%': '#FFFFFF80',
      '25%': '#FFFFFF40',
      '0%': '#FFFFFF00'
    },
    alvieBlack: {
      '100': '#232332',
      '75%': '#232332BF',
      '50%': '#23233280',
      '25%': '#23233240',
      '0%': '#23233200'
    },
    stone: {
      '90': '#F8FBFC',
      '100': '#EEF4F6',
      '110': '#D4E2E8',
      '120': '#B5C7D4',
      '150': '#7A93AB',
      '155': '#64778D',
      '160': '#465062',
      '180': '#34394A'
    }
  },
  semantic: {
    info: {
      '20': '#DDE4FD',
      '60': '#99AEF9',
      '90': '#6C8CFE',
      '100': '#5578F5',
      '110': '#3259E7',
      '120': '#254CD8',
      '140': '#2442AE',
      '160': '#243374',
      '05': '#F5F7FE',
      '30%': '#5578F54D'
    },
    success: {
      '20': '#CFEEE6',
      '40': '#9FDCCD',
      '90': '#12C194',
      '100': '#10A881',
      '110': '#0E9975',
      '120': '#0C7E61',
      '140': '#155A4E',
      '160': '#1A4745',
      '05': '#E8FDF7',
      '30%': '#10A8814D'
    },
    warning: {
      '40': '#FFD9B4',
      '60': '#FFC58E',
      '90': '#FFB269',
      '100': '#FF9F43',
      '110': '#FF830C',
      '120': '#B25700',
      '140': '#794214',
      '160': '#5C381E',
      '05': '#FFFAE8',
      '30%': '#FF9F434D'
    },
    error: {
      '20': '#FFDBDF',
      '40': '#FFB7C0',
      '90': '#FF6C7D',
      '100': '#FF4C61',
      '110': '#FF2B44',
      '120': '#E0001A',
      '140': '#950E24',
      '160': '#6F1529',
      '05': '#FFF0F5',
      '30%': '#FF4C614D'
    }
  },
  dataViz: {
    teal: {
      '20': '#C7F4EE',
      '50': '#B2ECE4',
      '90': '#2DBFAC',
      '100': '#0AA792',
      '110': '#088675',
      '120': '#14726C',
      '140': '#176562',
      '160': '#195858',
      '05': '#DCFDF8',
      '30%': '#0AA7924D'
    },
    orange: {
      '20': '#F7DFCC',
      '50': '#F3CFB2',
      '90': '#E08733',
      '100': '#D85E00',
      '110': '#AD4B00',
      '120': '#904614',
      '140': '#7E4119',
      '160': '#6B3B1E',
      '05': '#FBEFE5',
      '30%': '#D85E004D'
    },
    magneta: {
      '20': '#EFD4E0',
      '50': '#E8BED1',
      '90': '#C84B83',
      '100': '#B12765',
      '110': '#8E1F51',
      '120': '#782551',
      '140': '#6A254C',
      '160': '#5C2546',
      '05': '#F7E9F0',
      '30%': '#B127654D'
    },
    violet: {
      '20': '#EDE7F2',
      '50': '#DACAE2',
      '90': '#BB95D2',
      '100': '#A785BD',
      '110': '#886C9B',
      '120': '#725E85',
      '140': '#655478',
      '160': '#584A6A',
      '05': '#F6F2F9',
      '30%': '#A785BD4D'
    },
    andesite: {
      '20': '#D8D5DF',
      '50': '#B9B6C4',
      '90': '#8B869A',
      '100': '#4D4763',
      '110': '#3E394F',
      '120': '#38354B',
      '140': '#343146',
      '160': '#302E41',
      '05': '#E7E5ED',
      '30%': '#4D47634D'
    },
    cobalt: {
      '20': '#C9D3F8',
      '50': '#8B9DDC',
      '90': '#5974D3',
      '100': '#0028B6',
      '110': '#002092',
      '120': '#0E2681',
      '140': '#122674',
      '160': '#152567',
      '05': '#DFE6FF',
      '30%': '#0028B64D'
    },
    brown: {
      '20': '#F0DBD3',
      '50': '#DDB9AB',
      '90': '#AD6347',
      '100': '#9A411F',
      '110': '#7B3419',
      '120': '#6A3527',
      '140': '#5F3229',
      '160': '#532F2A',
      '05': '#FAECE7',
      '30%': '#9A411F4D'
    },
    pink: {
      '20': '#FAEBF8',
      '50': '#F6D0F4',
      '90': '#E683DE',
      '100': '#D86CCF',
      '110': '#B158AA',
      '120': '#904F90',
      '140': '#7E4880',
      '160': '#6B4071',
      '05': '#FBF0FA',
      '30%': '#D86CCF4D'
    },
    olive: {
      '20': '#EBF5B4',
      '50': '#D4E28C',
      '90': '#A3BF1B',
      '100': '#849F00',
      '110': '#6A7F00',
      '120': '#5D6D14',
      '140': '#546119',
      '160': '#4A551E',
      '05': '#F6FFC8',
      '30%': '#849F004D'
    },
    sienna: {
      '20': '#F0E7E4',
      '50': '#E2D1CA',
      '90': '#C4A092',
      '100': '#B58877',
      '110': '#916D5F',
      '120': '#7B605B',
      '140': '#6C5655',
      '160': '#5D4B4E',
      '05': '#F8F3F1',
      '30%': '#B588774D'
    },
    green: {
      '20': '#92C9BD',
      '50': '#92C9BD',
      '90': '#409583',
      '100': '#005F4B',
      '110': '#004C3C',
      '120': '#0E4741',
      '140': '#12413F',
      '160': '#153B3C',
      '05': '#D4E8E4',
      '30%': '#005F4B4D'
    },
    caramel: {
      '20': '#F6E6D5',
      '50': '#E9D2BA',
      '90': '#D99C57',
      '100': '#D0832D',
      '110': '#A66924',
      '120': '#8B5D2F',
      '140': '#7A5330',
      '160': '#684930',
      '05': '#FAF3EA',
      '30%': '#D0832D4D'
    },
    aqua: {
      '20': '#E6F5FB',
      '50': '#B4E2F3',
      '90': '#68BBE8',
      '100': '#049FD8',
      '110': '#037FAD',
      '120': '#106D96',
      '140': '#146185',
      '160': '#175574',
      '05': '#E6F5FB',
      '30%': '#049FD84D'
    },
    salmon: {
      '20': '#FBE1E1',
      '50': '#F9D2D2',
      '90': '#F4A6A6',
      '100': '#EC6A6A',
      '110': '#C55656',
      '120': '#9C4E54',
      '140': '#87474E',
      '160': '#733F48',
      '05': '#FDF0F0',
      '30%': '#EC6A6A4D'
    },
    brass: {
      '20': '#F7EEBF',
      '50': '#E6D994',
      '90': '#C2AA24',
      '100': '#AB9100',
      '110': '#897400',
      '120': '#756514',
      '140': '#675A19',
      '160': '#594F1E',
      '05': '#FFF8D4',
      '30%': '#AB91004D'
    }
  }
} as const satisfies PrimitivePalette

type ExtractColorValues<T> = T extends string
  ? T
  : T extends Record<string, unknown>
  ? { [K in keyof T]: ExtractColorValues<T[K]> }[keyof T]
  : never

export type PrimitiveColor = {
  [K in keyof typeof primitives]: ExtractColorValues<(typeof primitives)[K]>
}[keyof typeof primitives]

export default primitives
